export default {
    namespaced: true,
    state: {
        is_open: false,
        name: null,
        data: null,
    },
    actions: {
        close({ commit }) {
            commit('CLOSE');
        },
        open({ commit }, payload) {
            // Support both old format (string) and new format (object)
            if (typeof payload === 'string') {
                commit('OPEN', { name: payload, data: null });
            } else {
                commit('OPEN', payload);
            }
        }
    },
    mutations: {
        OPEN( state, { name, data = null }) {
            state.is_open = true;
            state.name = name;
            state.data = data;
        },
        CLOSE( state ) {
            state.is_open = false;
            state.name = null;
            state.data = null;
        }
    },
}
